// Spend categories are configured per award program and there is no categories
// endpoint, so the only list available to the portal is the union across the
// programs in scope. Deduped case-insensitively, keeping the first-seen casing,
// to match how CreateCategoriesModal builds its suggestions.
export const collectSpendCategories = programs => {
  const seen = new Map();
  for (const program of programs || []) {
    for (const category of program?.properties?.categories || []) {
      const trimmed = String(category ?? '').trim();
      const key = trimmed.toLowerCase();
      if (trimmed && !seen.has(key)) {
        seen.set(key, trimmed);
      }
    }
  }
  return [...seen.values()].sort((a, b) => a.localeCompare(b));
};

// A program's categories can be edited after grants are issued, so a row may show a
// category that is no longer selectable here. Deriving the options from the fetched
// rows instead would make the dropdown shift as data loads.
export const spendCategoryFilterOptions = programs => [
  { value: null, text: 'Category' },
  ...collectSpendCategories(programs).map(category => ({ value: category, text: category })),
];
